import { isAfter } from "date-fns";

export function isDateRangeValid(
  startDate: string,
  endDate: string,
  minDate: string | null = null,
  maxDate: string | null = null,
) {
  const minDateObject = minDate ? new Date(minDate) : null;
  const maxDateObject = maxDate ? new Date(maxDate) : null;
  const startDateObject = new Date(startDate);
  const endDateObject = new Date(endDate);

  if (endDateObject < startDateObject) {
    return false;
  }

  if (minDateObject && startDateObject < minDateObject) {
    return false;
  }

  if (maxDateObject && endDateObject > maxDateObject) {
    return false;
  }

  return true;
}

export function isValidDate(dateString: string) {
  // Date format: DD/MM/YYYY
  const datePattern = /^([012][0-9]|3[01])[/]([0][1-9]|1[012])[/]\d{4}$/;

  const matchArray = dateString.match(datePattern);

  if (!matchArray) {
    return false;
  }

  return true;
}

export function formattedDateInput(dateString: string): string {
  // Reject the last inputted character if it's invalid
  if (!"1234567890".includes(dateString.slice(-1)) || dateString.length >= 11) {
    return dateString.slice(0, -1);
  }

  // Insert the divider in the appropriate place
  if (dateString.length === 3 || dateString.length === 6) {
    return `${dateString.slice(0, -1)}/${dateString.slice(-1)}`;
  }

  return dateString;
}

export function getMinStartDate(startDate: string, minDate?: string): string {
  if (minDate && isAfter(new Date(minDate), new Date(startDate))) {
    return minDate;
  }

  return startDate;
}
